module.exports = __webpack_public_path__ + "static/img/72010A_6_R_20200801_LC.c609a6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/72010A_6_R_20200801_LC.png
// module id = ESW8
// module chunks = 0